import { render, staticRenderFns } from "./AnimalWeight.vue?vue&type=template&id=0845f43e&scoped=true&"
import script from "./AnimalWeight.vue?vue&type=script&lang=js&"
export * from "./AnimalWeight.vue?vue&type=script&lang=js&"
import style0 from "./AnimalWeight.vue?vue&type=style&index=0&id=0845f43e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0845f43e",
  null
  
)

export default component.exports